// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"564":"3a1957b5","596":"1749c8ab","673":"825c4eaf","782":"8fd7696b","866":"18f4011e","956":"88659bd7","986":"0b7ed77b"}[chunkId] + ".css";
};